import { render, staticRenderFns } from "./CustomersImportPage.vue?vue&type=template&id=92faa878&scoped=true"
import script from "./CustomersImportPage.vue?vue&type=script&lang=js"
export * from "./CustomersImportPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92faa878",
  null
  
)

export default component.exports